<template>
  <div class="payment-container">
    <v-layout row wrap>
      <v-flex lg12 md12>
        <v-container fluid>
          <v-form @submit.prevent="editMember()" ref="form" v-model="valid">
            <v-card flat class="futuristic-card">
              <v-container fluid>
                <h2 class="donation-title earth-color">Membership Details</h2>
                <div class="title-decoration"></div>
                <v-layout row wrap>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-select
                        label="Membership Type *"
                        v-model="member.member_setting"
                        @change="getResidence"
                        :items="allMemberSettings"
                        item-text="custom_name"
                        :return-object="true"
                        :rules="requiredRules"
                        required
                        :loading="$loadingTrue"
                        class="futuristic-input"
                      ></v-select>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-select
                        label="Residency *"
                        v-model="member.residence"
                        @change="getResidence"
                        :items="allResidenceTypes"
                        item-text="name"
                        item-value="public_id"
                        :rules="requiredRules"
                        required
                        :loading="$loadingTrue"
                        class="futuristic-input"
                      ></v-select>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-select
                        label="Type of Household"
                        v-model="member.household_type"
                        :items="allHouseHoldTypes"
                        item-text="name"
                        item-value="public_id"
                        :rules="requiredRules"
                        required
                        :loading="$loadingTrue"
                        class="futuristic-input"
                      ></v-select>
                    </v-container>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
            <br />
            <v-card flat class="futuristic-card">
              <v-container fluid>
                <h2 class="donation-title earth-color">Personal Information</h2>
                <div class="title-decoration"></div>
                <v-layout row wrap>
                  <v-flex lg4 md4 sm12 xs12 v-if="$currentUrl === 'NewMember'">
                    <v-container>
                      <v-text-field
                        label="Member ID"
                        v-model="member.member_id"
                        :rules="requiredRules"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12 v-if="$currentUrl === 'NewMember'">
                    <v-container>
                      <v-text-field
                        label="Salesforce Opportunity ID"
                        v-model="member.salesforce_uuid"
                        :rules="requiredRules"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12 v-if="$currentUrl === 'NewMember'">
                    <v-container>
                      <v-text-field
                        label="Salesforce Account ID"
                        v-model="member.salesforce_account_uuid"
                        :rules="requiredRules"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12 v-if="$currentUrl === 'NewMember'">
                    <v-container>
                      <v-text-field
                        label="Salesforce Contact ID"
                        v-model="member.salesforce_contact_uuid"
                        :rules="requiredRules"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12 v-if="$currentUrl === 'NewMember'">
                    <v-container>
                      <v-dialog
                        ref="dialog2"
                        persistent
                        v-model="modal2"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="member.expiry_date"
                      >
                        <v-text-field
                          slot="activator"
                          label="Membership Expiry Date"
                          v-model="member.expiry_date"
                          :rules="requiredRules"
                          readonly
                          class="futuristic-input"
                        ></v-text-field>
                        <v-date-picker v-model="member.expiry_date" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn
                            depressed
                            flat
                            color="#587e27"
                            @click="modal2 = false"
                            class="futuristic-btn"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            depressed
                            flat
                            color="#587e27"
                            @click="$refs.dialog2.save(member.expiry_date)"
                            class="futuristic-btn"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-select
                        label="Title"
                        v-model="member.title"
                        :items="['Mr.', 'Mrs.', 'Ms.', 'Dr.', 'Eng.', 'Prof.']"
                        :rules="[(v) => !!v || 'Title is required']"
                        required
                        :loading="$loadingTrue"
                        class="futuristic-input"
                      ></v-select>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        v-model="member.first_name"
                        :rules="requiredRules"
                        label="First Name"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        v-model="member.sur_name"
                        :rules="requiredRules"
                        label="Last Name"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-select
                        label="Gender"
                        v-model="member.gender_id"
                        :items="allGender"
                        :rules="[(v) => !!v || 'Gender is required']"
                        item-text="name"
                        item-value="public_id"
                        required
                        :loading="$loadingTrue"
                        class="futuristic-input"
                      ></v-select>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-dialog
                        ref="dialog"
                        persistent
                        v-model="modal1"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="member.dob"
                      >
                        <v-text-field
                          slot="activator"
                          label="Date of Birth"
                          v-model="member.dob"
                          :rules="requiredRules"
                          readonly
                          class="futuristic-input"
                        ></v-text-field>
                        <v-date-picker
                          v-model="member.dob"
                          :max="start_date"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            depressed
                            flat
                            color="#587e27"
                            @click="modal1 = false"
                            class="futuristic-btn"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            depressed
                            flat
                            color="#587e27"
                            @click="$refs.dialog.save(member.dob)"
                            class="futuristic-btn"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        v-model="member.id_alien_number"
                        label="ID Number/Alien ID (Required for every visit)"
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        v-model="member.postal_address"
                        :rules="requiredRules"
                        label="Postal Address"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        v-model="member.postal_code"
                        :rules="requiredRules"
                        label="Postal Code"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        v-model="member.email"
                        :rules="emailRules"
                        label="Email"
                        required
                        type="email"
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg3 md6 sm12 xs12>
                    <v-container>
                      <v-autocomplete
                        label="Country"
                        v-model="member.code"
                        :items="allCountries"
                        :rules="[(v) => !!v || 'Country is required']"
                        required
                        item-text="name"
                        item-value="code"
                        @change="findCountryCode"
                        :loading="$loadingTrue"
                        class="futuristic-input"
                      ></v-autocomplete>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        v-model="member.tel_number"
                        :rules="requiredRules"
                        label="Phone Number (e.g. +XXX...)"
                        required
                        minlength="13"
                        type="text"
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        v-model="member.member_id"
                        :rules="requiredRules"
                        label="Membership ID"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-select
                        label="Payment Method"
                        v-model="member.payment_method"
                        :items="['Mpesa', 'Credit Card', 'Bank Transfer', 'Cheque', 'Voucher']"
                        :rules="requiredRules"
                        required
                        :loading="$loadingTrue"
                        class="futuristic-input"
                      ></v-select>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-dialog
                        ref="dialogED"
                        persistent
                        v-model="modalED"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="member.expiry_date"
                      >
                        <v-text-field
                          slot="activator"
                          label="Expiry Date"
                          v-model="member.expiry_date"
                          :rules="requiredRules"
                          readonly
                          class="futuristic-input"
                        ></v-text-field>
                        <v-date-picker v-model="member.expiry_date" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn
                            depressed
                            flat
                            color="#587e27"
                            @click="modalED = false"
                            class="futuristic-btn"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            depressed
                            flat
                            color="#587e27"
                            @click="$refs.dialogED.save(member.expiry_date)"
                            class="futuristic-btn"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        v-model="member.salesforce_account_uuid"
                        :rules="requiredRules"
                        label="Salesforce Account ID"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        v-model="member.salesforce_contact_uuid"
                        :rules="requiredRules"
                        label="Salesforce Contact ID"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-container>
                      <v-text-field
                        v-model="member.salesforce_uuid"
                        :rules="requiredRules"
                        label="Salesforce Opportunity ID"
                        required
                        class="futuristic-input"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                </v-layout>
                {{ updateMember }}
              </v-container>
            </v-card>
            <br />
            <v-container>
              <v-switch
                color="#587e27"
                label="Is Paid"
                v-model="member.payment_status"
                required
                class="futuristic-input"
              ></v-switch>
            </v-container>
            <v-btn
              depressed
              color="#587e27"
              type="submit"
              block
              large
              :loading="$loadingTrue"
              class="futuristic-btn donate-btn"
            >
              Update Info
            </v-btn>
          </v-form>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: "EditMember",
  data() {
    return {
      start_date: this.$moment().subtract(18, "years").format("YYYY-MM-DD"),
      requiredRules: [(v) => !!v || "This field is required"],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      valid: true,
      menu1: false,
      modal1: false,
      modal2: false,
      dialogED: false,
      modalED: false,
      dob_config: {
        maxDate: this.$moment().subtract(18, "years").format("YYYY-MM-DD"),
      },
      dob_config2: {
        maxDate: "today",
      },
      member: {
        public_id: this.$route.params.member_id,
        member_id: "",
        salesforce_uuid: "",
        salesforce_account_uuid: "",
        salesforce_contact_uuid: "",
        payment_status: false,
        expiry_date: "",
        member_setting: "",
        registration_type: "76f0a89",
        title: "",
        first_name: "",
        sur_name: "",
        email: "",
        code: "",
        payment_method: "",
        tel_number: "",
        registration_date: "",
        postal_address: "",
        id_alien_number: "",
        gender_id: "",
        postal_code: "",
        dob: this.$moment().subtract(18, "years").format("YYYY-MM-DD"),
        residence: "",
        household_type: "",
        children: "",
        promo_code: "",
        family: [],
        town: "",
        redirect_url: "Member",
      },
      residence: {},
      existing_member: false,
      household: false,
    };
  },
  created() {
    this.$store.dispatch("get_all_countries");
    this.$store.dispatch("get_all_membership_settings");
    this.$store.dispatch("get_all_genders");
    this.$store.dispatch("get_all_residence_types");
    this.$store.dispatch("get_all_house_holds");
  },
  methods: {
    findCountryCode(data) {
      var instance = this;
      this.allCountries.map(function (country) {
        if (data === country.code) {
          instance.member.tel_number = "+" + country.calling_code;
        }
      });
    },
    getResidence: function (data) {
      this.residence = data;
      this.member.member_setting = this.residence.public_id;
      this.$store.commit("GET_LOCAL_MEMBERS", this.residence);
    },
    editMember() {
      this.$store.dispatch("update_member", this.member);
    },
  },
};
</script>

<style scoped>
/* Futuristic Container */
.payment-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.payment-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
}

.donation-title {
  color: #587e27;
  font-weight: 600;
  font-size: 1.5rem;
  margin-bottom: 8px;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.donate-btn {
  font-size: 1.1rem;
  padding: 12px;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .payment-container {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .donation-title {
    font-size: 1.25rem;
  }

  .futuristic-btn {
    font-size: 0.9rem;
  }
}

@media (max-width: 600px) {
  .payment-container {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .donation-title {
    font-size: 1.1rem;
  }

  .futuristic-btn {
    font-size: 0.85rem;
  }

  .donate-btn {
    font-size: 1rem;
    padding: 10px;
  }
}
</style>
